module.exports = __webpack_public_path__ + "img/右箭头.e607b529.png";